import { render, staticRenderFns } from "./Task_StudentCart.vue?vue&type=template&id=19270d5a&scoped=true&"
import script from "./Task_StudentCart.vue?vue&type=script&lang=js&"
export * from "./Task_StudentCart.vue?vue&type=script&lang=js&"
import style0 from "./Task_StudentCart.vue?vue&type=style&index=0&id=19270d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19270d5a",
  null
  
)

export default component.exports